import { type FC } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { Tailwind } from 'styles/tw';

export type Props = {
  periodTitleImageUrl: string;
  periodText: string;
  periodTextContainerBorderColor: Tailwind['borderColor'];
  isLineWrap?: boolean;
};

export const Period: FC<Props> = ({ periodTitleImageUrl, periodText, periodTextContainerBorderColor, isLineWrap }) => {
  const periodTextWithoutNewLine = periodText.replace(/\n/g, '');
  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <div id="period-title" className="w-full flex justify-center items-center">
        <NextImage src={periodTitleImageUrl} alt="period-title" width={160} height={40} />
      </div>
      <div
        className={`flex justify-center border-y ${periodTextContainerBorderColor} border-solid p-5 semiLg:w-[916px]`}
      >
        <p className="semiLg:hidden text-lg font-medium">{periodText}</p>
        <p className="hidden semiLg:block text-lg font-medium">{isLineWrap ? periodText : periodTextWithoutNewLine}</p>
      </div>
    </div>
  );
};
